import { render, staticRenderFns } from "./maintain-table.vue?vue&type=template&id=785bc8ca&scoped=true"
import script from "./maintain-table.vue?vue&type=script&lang=js"
export * from "./maintain-table.vue?vue&type=script&lang=js"
import style0 from "./maintain-table.vue?vue&type=style&index=0&id=785bc8ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785bc8ca",
  null
  
)

export default component.exports